<template>
    <div class="row" style="height: 100%;">
        <div class="col-12">
            <div @click="remove" v-show="showStyle && isUserEdit" class="button-remove" style="width: 17px; height: 17px; top: 5px;">
                <i class="pi pi-times" style="font-size: 10px; position: relative; bottom: 2px; color: black;"/>
            </div>
            <Dropdown v-model="card1" v-show="showStyle" style="width: 100%; height: 50%;" class="drop-side-cards"
                      :options="cardsOptions" optionLabel="name" @change="handleDropDownChange($event)"
                      :placeholder="placeholderSel" appendTo="tableDiv" :disabled="!isUserEdit"/>

            <div class="card" v-show="showStyle" style="width: 100%; height: 50%;">
                {{ formatValue(card1Data) }}
            </div>

            <div v-show="!showStyle"
                 style="margin: 100px 30px 0px 30px; padding: 10px; border: 1px solid gray; border-radius: 7px;">
                <h2 style="font-size: 20px; text-align: center;">{{ card1.name }}</h2>

                <div style="width: 100%; text-align: center;">
                    <span style="font-size: 17px;">{{ formatValue(card1Data) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dropdown from 'primevue/dropdown';
import {optionsSideCards} from './chartsOptions';
import retrieveData from '../../../mixins/ReportsMixin';
import i18n from '../../../i18n';
import idb from '../../../api/idb';
import {formatHours} from "@/utils/hourFormat";
import {MODE, area, efficiency, engineOnTime, eventsByMode, fuelPerHectare, fuelRateByTime, mechanicalAvailability, productivity, speed, totalFuel, totalTime} from "@/utils/indicators";

export default {
    mixins: [retrieveData],
    mounted() {
        this.cardsOptions = optionsSideCards()
        this.placeholderSel = i18n.t('AppAnalysisSideCards.Selecione')
    },
    data() {
        return {
            is_pdf: false,
            modelLocalStorage: 0,
            indexInModelLocalStorage: 0,
            cardsData: null,
            placeholderSel: null,
            card1: {},
            showStyle: true,
            card1Data: 'N/D',
            cardsOptions: null,
            storedChosenCards: {},
            id: 0,
            templates: null,
            isUserEdit: false
        }
    },
    methods: {
        setModelLocalStorage(index, code) {
            this.modelLocalStorage = index;
            this.indexInModelLocalStorage = code
        },
        isPdf(val) {
            this.is_pdf = val;
        },
        cleanStyle() {
            this.showStyle = !this.showStyle
        },
        remove() {
            this.$emit('remove', this.id);
        },
        correctHeight() {
            // console.log("AA");
        },
        fillCards() {
            this.card1Data = this.getCardData(this.card1.code);
        },
        getCardData(option) {
            if (!this.cardsData) {
                return 'N/D';
            }

            let events = this.cardsData;

            switch (option) {
                case 'AREA':
                    return {value: area(events), symbol: 'ha'};
                case 'PRODUTIVIDADE':
                    return {value: productivity(events), symbol: 'ha/h'};
                case 'DISP_MECANICA':
                    return {value: mechanicalAvailability(events), symbol: '%'};
                case 'RENDIMENTO':
                    return {value: fuelPerHectare(events), symbol: 'L/ha'};
                case 'CONSUMO':
                    return {value: fuelRateByTime(events), symbol: 'L/h'};
                case 'COMBUSTIVEL':
                    return {value: totalFuel(events), symbol: 'L'};
                case 'VELOCIDADE_MEDIA':
                    return {value: speed(events), symbol: 'km/h'};
                case 'EFICIENCIA':
                    return {value: efficiency(events), symbol: '%'};
                case 'TEMPO':
                    return {value: engineOnTime(events), symbol: 'h'};
                case 'TEMPO_TRABALHANDO':
                    return {value: totalTime(eventsByMode(events, MODE.PRODUCING)), symbol: 'h'};
                case 'TEMPO_MANOBRANDO':
                    return {value: totalTime(eventsByMode(events, MODE.MANEUVERING)), symbol: 'h'};
                case 'TEMPO_DESLOCANDO':
                    return {value: totalTime(eventsByMode(events, MODE.TRAVELING)), symbol: 'h'};
                case 'TEMPO_PARADO':
                    return {value: totalTime(eventsByMode(events, MODE.IDLE)), symbol: 'h'};
                case 'CONSUMO_TRABALHANDO':
                    return {value: totalFuel(eventsByMode(events, MODE.PRODUCING)), symbol: 'L'};
                case 'CONSUMO_MANOBRANDO':
                    return {value: totalFuel(eventsByMode(events, MODE.MANEUVERING)), symbol: 'L'};
                case 'CONSUMO_DESLOCANDO':
                    return {value: totalFuel(eventsByMode(events, MODE.TRAVELING)), symbol: 'L'};
                case 'CONSUMO_PARADO':
                    return {value: totalFuel(eventsByMode(events, MODE.IDLE)), symbol: 'L'};
                default:
                    return 'N/D';
            }
        },
        formatValue(val) {
            if (!val || !val.value || val.value === 'N/D' || !isFinite(val.value)) {
                return 'N/D';
            }

            if (val.symbol === 'h') {
                return formatHours(val.value);
            }

            if (val.isInteger) {
                return val.symbol ? val.value + ' ' + val.symbol : val.value;
            }

            if (!val.symbol) {
                return val.value.toFixed(2);
            }

            return val.value.toFixed(2) + ' ' + val.symbol;
        },
        findCardByCode(cardName) {
            if (this.cardsOptions.find(x => x.code === this.storedChosenCards[cardName]) !== undefined) {
                return this.cardsOptions.find(x => x.code === this.storedChosenCards[cardName]);
            }
            return {};
        },
        handleDropDownChange(event) {
            let val = {
                name: event.value.name,
                code: event.value.code,
                sumInGroupMode: false,
                id: this.id
            }

            this.$emit('dropdownChanged', val);
        },
        dataWatch(filterEventsResults, chartDataFromIdb, filterTime, chartUpdater, chartDataToSideCards, templates, isUserEdit) {
            this.isUserEdit = isUserEdit;
            this.templates = templates;
            this.cardsData = chartDataToSideCards;
            this.fillCards();
        },
        setLocalStorage(count) {
            this.id = count;
        },
        setOption() {
            if(!this.templates) {
                return
            }

            let temp = this.templates;

            temp[this.modelLocalStorage][this.indexInModelLocalStorage].value.forEach(element => {
                if (element.id === this.id) {
                    this.card1 = {name: element.name, code: element.code};
                }
            });
        },
        setNoValue() {
            this.card1Data = [];
        },
    },
    watch: {
        statistics_data: function (val) {
            this.cardsData = val;
            this.fillCards();
        },
        card1: function (val) {
            if (!val.code) {
                return;
            }
            this.card1Data = this.getCardData(val.code);
        }
    },
    components: {
        Dropdown
    }
}
</script>

<style scoped type="scss">

.card {
    padding: 10px;
    color: #4b4b4b;
    border-radius: 3px;
    font-size: 20px;
    background-color: #fff;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.drop-side-cards {
    justify-content: center;
    align-items: center;
    text-align: center;
}

</style>
